import { render, staticRenderFns } from "./AdministrativeCentersHandler.vue?vue&type=template&id=705e84b5"
import script from "./AdministrativeCentersHandler.vue?vue&type=script&lang=js"
export * from "./AdministrativeCentersHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports